import { detectAdBlock } from "~/lib/ad-block";
import { gtag } from "~/lib/gtag";
export function computeGACampaignKey(name, variant) {
  const skippedVariant = new Set(["0", "1"]);
  return skippedVariant.has(variant) ? name : `${name}-${variant}`;
}
let getGaClientIdFromGTMPromise;
export async function getGAClientIdFromGTM(profileId) {
  if (getGaClientIdFromGTMPromise !== undefined) return getGaClientIdFromGTMPromise;
  const hasAdBlock = await detectAdBlock();
  getGaClientIdFromGTMPromise = hasAdBlock ? Promise.resolve(undefined) : new Promise(resolve => {
    setTimeout(() => {
      resolve(undefined);
    }, 5000);
    gtag("get", profileId, "client_id", clientId => resolve(clientId));
  });
  return getGaClientIdFromGTMPromise;
}
export async function sendGAEvent(payload) {
  try {
    const requestPayload = {
      cid: payload.clientId,
      ea: payload.event.action,
      ec: payload.event.category,
      el: payload.event.label,
      t: "event",
      tid: payload.trackingId,
      v: 1
    };
    if (location.hostname) requestPayload.dh = location.hostname;
    if (location.origin) requestPayload.dl = location.origin;
    const body = Object.entries(requestPayload).map(([key, value]) => `${key}=${encodeURIComponent(value)}`).join("&");
    const response = await fetch("https://www.google-analytics.com/collect", {
      body,
      method: "POST"
    });
    if (!response.ok) {
      const responseText = await response.text();
      throw new Error(`Bad response from Google Analytics: ${response.status}\n${responseText}`);
    }
  } catch (error) {
    console.error(new Error("Failed to send GA event", {
      cause: error
    }));
  }
}